import TrainingPage from './components/TrainingPage';

export default TrainingPage;
